'use strict';
module.exports = function CorsProxyFallbackDownloader(config, navigatorModel, ajaxProvider, fallBackImageUrl) {
	let fallBackimage;
	const self = this,
		imageApiCorsProxy = function (url) {
			return config.imageApiUrl + '/proxyUrl?url=' + encodeURIComponent(url);
		},
		requestFallBackimage = function () {
			if (fallBackimage) {
				return Promise.resolve(fallBackimage);
			}
			return navigatorModel.convertToPng(fallBackImageUrl).then(function (result) {
				fallBackimage = result;
				return result;
			});
		};

	self.convertToPng = self.downloadAsDataUri = function (url, width, height) {
		const downloadViaProxy = function (reason) {
			if (reason === 'network-error') {
				return requestFallBackimage();
			}

			return ajaxProvider.get(imageApiCorsProxy(url)).then(function (response) {
				return navigatorModel.downloadAsDataUri(response);
				//return navigatorModel.convertToPng(response, options);
			}).catch(requestFallBackimage);
		};
		return navigatorModel.convertToPng(url, width, height).catch(downloadViaProxy);
	};
};
